import _taggedTemplateLiteral from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _classCallCheck from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        :host {\n          display: inline-block;\n          position: relative;\n        }\n        a, a:hover, a:visited {\n          color: inherit;\n          outline: none;\n          display: inline-block;\n          white-space: nowrap;\n          text-decoration: none;\n          border: none;\n        }\n        path {\n          stroke: var(--wired-link-decoration-color, blue);\n          stroke-opacity: 0.45;\n        }\n        a:focus path {\n          stroke-opacity: 1;\n        }\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    <a href=\"", "\" target=\"", "\">\n      <slot></slot>\n      <div id=\"overlay\"><svg></svg></div>\n    </a>\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { customElement, property, css, html, query } from 'lit-element';
import { WiredBase, BaseCSS } from 'wired-lib/lib/wired-base';
import { line } from 'wired-lib';

var WiredLink = /*#__PURE__*/function (_WiredBase) {
  _inherits(WiredLink, _WiredBase);

  var _super = _createSuper(WiredLink);

  function WiredLink() {
    var _this;

    _classCallCheck(this, WiredLink);

    _this = _super.apply(this, arguments);
    _this.elevation = 1;
    return _this;
  }

  _createClass(WiredLink, [{
    key: "render",
    value: function render() {
      return html(_templateObject(), this.href, this.target || '');
    }
  }, {
    key: "focus",
    value: function focus() {
      if (this.anchor) {
        this.anchor.focus();
      } else {
        _get(_getPrototypeOf(WiredLink.prototype), "focus", this).call(this);
      }
    }
  }, {
    key: "canvasSize",
    value: function canvasSize() {
      if (this.anchor) {
        var size = this.anchor.getBoundingClientRect();
        var elev = Math.min(Math.max(1, this.elevation), 5);
        var w = size.width;
        var h = size.height + (elev - 1) * 2;
        return [w, h];
      }

      return this.lastSize;
    }
  }, {
    key: "draw",
    value: function draw(svg, size) {
      var elev = Math.min(Math.max(1, this.elevation), 5);
      var s = {
        width: size[0],
        height: size[1] - (elev - 1) * 2
      };

      for (var i = 0; i < elev; i++) {
        line(svg, 0, s.height + i * 2 - 2, s.width, s.height + i * 2 - 2, this.seed);
        line(svg, 0, s.height + i * 2 - 2, s.width, s.height + i * 2 - 2, this.seed);
      }
    }
  }], [{
    key: "styles",
    get: function get() {
      return [BaseCSS, css(_templateObject2())];
    }
  }]);

  return WiredLink;
}(WiredBase);

__decorate([property({
  type: Number
}), __metadata("design:type", Object)], WiredLink.prototype, "elevation", void 0);

__decorate([property({
  type: String
}), __metadata("design:type", String)], WiredLink.prototype, "href", void 0);

__decorate([property({
  type: String
}), __metadata("design:type", String)], WiredLink.prototype, "target", void 0);

__decorate([query('a'), __metadata("design:type", HTMLAnchorElement)], WiredLink.prototype, "anchor", void 0);

WiredLink = __decorate([customElement('wired-link')], WiredLink);
export { WiredLink };